<template>
    <div>
        <b-row>
            <b-col>
                <app-complete-report-filters
                    @filter="onFilter"
                ></app-complete-report-filters>
            </b-col>
        </b-row>
        <b-row>
            <b-col class="d-flex justify-content-center">
                <app-sub-title
                    v-if="!!from && !!to"
                    :text="
                        `Periodo: ${moment(from).format(
                            'DD/MM/YYYY'
                        )} - ${moment(to).format('DD/MM/YYYY')}`
                    "
                ></app-sub-title>
                <app-sub-title v-else text="Total"></app-sub-title>
            </b-col>
        </b-row>
        <b-row>
            <b-col>
                <app-complete-report-charts
                    :pqrs="pqrs"
                ></app-complete-report-charts>
            </b-col>
        </b-row>
    </div>
</template>
<script>
import appCompleteReportFilters from './CompleteReportFilters'
import appCompleteReportCharts from './CompleteReportCharts'
export default {
    components: {
        appCompleteReportFilters,
        appCompleteReportCharts,
    },
    data: () => ({
        filters: null,
        pqrs: null,
        from: '',
        to: '',
    }),
    computed: {},
    methods: {
        onFilter(filters) {
            this.filters = filters
            this.loadPqrs()
        },
        async loadPqrs() {
            const { data } = await repo.get(
                'reporting/company/pqrs/complete',
                this.filters
            )
            const byType = [['Tipo', 'Total']].concat(
                data.byType.map(item => [item.name, item.total])
            )
            const byClient = [['Tipo', 'Total']].concat(
                data.byClient.map(item => [item.name, item.total])
            )
            const byStatus = [['Tipo', 'Total']].concat(
                data.byStatus.map(item => [item.name, item.total])
            )
            const byUser = [['Tipo', 'Total']].concat(
                data.byUser.map(item => [item.name, item.total])
            )
            this.pqrs = {
                byType,
                byClient,
                byStatus,
                byUser,
            }
            this.from = data.from
            this.to = data.to
        },
    },
    mounted() {
        this.loadPqrs()
    },
}
</script>
